<template>
  <div v-if="isTest && product.template === 'test-buy-box'" class="subscription__options-container">
    <div class="option-group_label">Feel secure in your purchase with our 60-day money-back happiness guarantee!</div>
    <div class="subscription__options">
      <div v-if="hasMultiPack || hasSubscription" class="subscription__purchase" :data-selected="isSubscription" data-buying-option="subscription">
        <div class="subscription__input">
          <label>
            <input type="radio" class="hide" :checked="isSubscription" @change="onSubscriptionChange(true)">
            <div class="subscription__input-label">
              <div class="subscription__input-left">
                <span class="subscription__input-title text-xl mobile-text-lg">Subscribe</span>
                <div class="subscription__input-badge text-xl mobile-text-lg">
                  & Save {{ optionDiscountPercentage }}%
                </div>
              </div>
              <div class="subscription__input-right">
                <div class="text-xl mobile-text-lg subscription__input-price">
                  {{ subscriptionPrice }}
                </div>
              </div>
            </div>
          </label>
          <div class="subscription__description mobile-text-sm">Choose your delivery frequency, cancel anytime</div>
        </div>
        
        <div class="subscription__frequency-container">
          <div class="subscription__product-option-save">
            <span v-if="isSubscription">
              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="5.5" cy="7.33525" r="5" stroke="#0A323C"/>
                <path d="M3.66699 6.298C5.00033 7.03142 5.66699 8.49809 5.66699 8.49809L11.0003 1.16476" stroke="#0A323C"/>
              </svg>Saving
            </span>
            <span v-else>Save</span>
            &nbsp;{{ savePrice }}
          </div>

          <div v-if="isSubscription" :class="['subscription__frequency-drpdwn' , {'open': isFrequencyDrpdwnOpen}]" @click="toggleFrequencyDrpdwn">
            <div class="subscription__frequency-drpdwn-selected">{{ isFrequencyDrpdwnOpen ? '' :selectedSellingPlan.name }}</div>
            <div class="subscription__frequency-drpdwn-arrow"></div>
            <div class="subscription__frequency-drpdwn-options" v-if="isFrequencyDrpdwnOpen">
              <div
                v-for="option in renderSubFrequency" 
                :key="option.id" 
                :class="['subscription__frequency-drpdwn-option', {'selected': selectedSellingPlan.name === option.name}]" 
                @click="emit('update-selling-plan',option, true)"
              >
                {{ option.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="buybox__ot-container" :data-selected="!isSubscription" data-buying-option="onetime">
        <label>
          <input type="radio" class="hide" :checked="!isSubscription" @change="onSubscriptionChange(false)">
          <div class="subscription__input-label">
            <div class="subscription__input-title text-xl mobile-text-lg">
              One time purchase
            </div>
            <div class="subscription__input-price text-xl mobile-text-lg">{{ onetimePrice }}</div>
          </div>
        </label>
      </div>
    </div>
  </div>


  <div v-else class="subscription__options-container">
    <div class="option-group_label text-base mobile-text-sm">Frequency</div>
    
    <div class="subscription__options">
      <div v-if="hasMultiPack || hasSubscription" class="subscription__purchase">
        <div class="subscription__input">
          <label>
            <input type="radio" :checked="isSubscription" @change="onSubscriptionChange(true)">
            <div class="subscription__input-label">
              <div class="subscription__input-left">
                <span class="subscription__input-title text-base" :class="{'is--bold': isSubscription}">Subscribe</span>
                <div class="subscription__input-badge text-sm mobile-text-xs">
                  Save {{ optionDiscountPercentage }}%
                </div>
              </div>
              <div class="subscription__input-right">
                <div class="text-lg mobile-text-base subscription__input-compare-price">
                  {{ compareAtPrice ? compareAtPrice : onetimePrice }}
                </div>
                <div class="text-lg mobile-text-base subscription__input-price">
                  {{ subscriptionPrice }}
                </div>
              </div>
            </div>
          </label>
        </div>
        <div v-if="isMultiPack && isSubscription" class="subscription__product-options">
          <template v-for="(option, optionIndex) in multipackOptions" :key="optionIndex">
            <div class="subscription__product-option">
              <div 
                v-for="(value, index) in option.values"
                :key="index"
                class="subscription__product-option-inner"
                @click="onSubscriptionOptionChange(option.name, value, (option.position-1))"
              >
                <div :class="['option-chip', { 'selected': option.selected === value }]">
                  <span class="text-base mobile-text-sm">{{ value }}</span>
                  <div class="option__price text-sm mobile-text-xs">
                    {{ getOptionUnitPrice(value) }} each
                  </div>
                </div>
                <div v-if="multipackOptionTag(option.position,value)" class="subscription__product-option-tag">
                  {{ multipackOptionTag(option.position,value) }}
                </div>
              </div>
            </div>
          </template>
        </div>        
        <div v-if="isSubscription" class="subscription__frequency-container">
          <div class="subscription__frequency-title">
            <svg class="subscription__frequency-icon">
              <use href="#recurring"></use>
            </svg>
            Delivered every:
          </div>
          <div :class="['subscription__frequency-drpdwn' , {'open': isFrequencyDrpdwnOpen}]" @click="toggleFrequencyDrpdwn">
            <div class="subscription__frequency-drpdwn-selected">{{ isFrequencyDrpdwnOpen ? 'Select Option' :selectedSellingPlan.name }}</div>
            <div class="subscription__frequency-drpdwn-arrow"></div>
            <div class="subscription__frequency-drpdwn-options" v-if="isFrequencyDrpdwnOpen">
              <div
                v-for="option in renderSubFrequency" 
                :key="option.id" 
                :class="['subscription__frequency-drpdwn-option', {'selected': selectedSellingPlan.name === option.name}]" 
                @click="emit('update-selling-plan',option, true)"
              >
                {{ option.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="buybox__ot-container">
        <label>
          <input type="radio" :checked="!isSubscription" @change="onSubscriptionChange(false)">
          <div class="subscription__input-label">
            <div class="subscription__input-title" :class="{'is--bold': !isSubscription}">
              One time purchase
            </div>
            <div class="text-lg mobile-text-base subscription__input-price">{{ onetimePrice }}</div>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { toRefs, ref, onMounted, computed } from 'vue';

  const props = defineProps({
    product: {
      type: Object,
      required: true,
    },

    selectedVariant: {
      type: Object,
      default: null,
    },

    isMultiPack: {
      type: Boolean,
      default: false
    },

    isSubscriptionProp: {
      type: Boolean,
      default: true
    },

    selectedSellingPlan: {
      type: Object,
      default: null
    },

    isTest: {
      type: Boolean,
      default: false, 
    }
  })
  
  const { product, selectedVariant, isMultiPack, isSubscriptionProp, selectedSellingPlan, isTest } = toRefs(props);
  var isSubscription = ref(false);
  const isFrequencyDrpdwnOpen = ref(false);

  const emit = defineEmits(['update-option','update-selling-plan','update-is-subscription']);

  onMounted(() => {
    if(hasSubscription.value && isSubscriptionProp.value){
      isSubscription.value = true;
    }
  })

  const hasMultiPack = computed(() => {
    const { variants } = product.value;
    const { options } = selectedVariant.value;

    const filterVariants = () => {
      if (options.length === 3) {
        return variants.filter(variant =>
          variant.options[0] === options[0] &&
          variant.options[1] === options[1]
        );
      } else if (options.length === 2) {
        return variants.filter(variant =>
          variant.options[0] === options[0]
        );
      }
      return [];
    };

    const hasAvailableVariants = filterVariants();
    return hasAvailableVariants.length > 1 && isMultiPack.value;
  });

  const hasSubscription = computed(() => {
    const { has_subscription} = product.value;
    const { has_subscription_plan } = selectedVariant.value;

    return has_subscription && has_subscription_plan
  })

  const optionDiscountPercentage = computed(() => {
    if (!isSubscription.value) {
      const availableSubscriptionVariant = subscriptionVariants();

      if (availableSubscriptionVariant) {
        return getDiscountPercentage(availableSubscriptionVariant);
      } else {
        return 0;
      }
    }else {
      return getDiscountPercentage(selectedVariant.value);
    }
  })

  /*-- Test [template: test-buy-box] - start --*/
  const savePrice = computed(() => {
    if (!isSubscription.value) {
      const availableSubscriptionVariant = subscriptionVariants();
      if (availableSubscriptionVariant) {
        const { compare_at_price: compareAtPrice, price: subscriptionPrice } = availableSubscriptionVariant;
            return window.formattedPrice((compareAtPrice - subscriptionPrice)/100);
      } else {
        return null;
      }
    } else {
      var item = selectedVariant.value || product.value.variants[0]
      return item.compare_at_price > 0 ? window.formattedPrice(item.compare_at_price/100 - item.price/100) : null;
    }
  })
  /*-- Test [template: test-buy-box] - end --*/

  const compareAtPrice = computed(() => {
    var item = selectedVariant.value || product.value.variants[0]
    return item.compare_at_price > 0 ? window.formattedPrice(item.compare_at_price/100) : null;
  })

  const onetimePrice = computed(() => {
    const { variants } = product.value;
    var item = selectedVariant.value || variants[0];
    const { options } = item;

    const onetimeVariants = variants.filter(variant =>
      options.slice(0, options.length - 1).every((option, index) =>
        variant.options[index] === option
      ) && variant.options[options.length - 1] === 'One Time Purchase'
    );

    if (onetimeVariants.length > 0) {
      return window.formattedPrice(onetimeVariants[0].price/100)
    } else {
      return window.formattedPrice(item.price/100);
    }
  })

  const subscriptionPrice = computed(() => {
    const { variants } = product.value;
    const item = selectedVariant.value || variants[0];

    if (item.has_subscription_plan) {
      return getFormattedPrice(item.price, item.selling_plans);
    } else {
      const availableSubscriptionVariant = subscriptionVariants(item)

      if (availableSubscriptionVariant) {
        const sellingPlan = availableSubscriptionVariant.selling_plans[0];
        emit('update-selling-plan', {
          id: sellingPlan.selling_plan.id,
          name: sellingPlan.selling_plan.name,
        }, false);
        return getFormattedPrice(availableSubscriptionVariant.price, availableSubscriptionVariant.selling_plans);
      } else {
        return window.formattedPrice(0.00);
      }
    }
  })

  const multipackOptions = computed(() => {
    return product.value.options.map((option, optionIndex) => {
      return {
        ...option,
        values: option.values.filter((value) => isVariantOptionAvailable(optionIndex, value) && value.toLowerCase() !== 'one time purchase')
      };
    }).filter(option => isMultiPackOption(option));
  })

  const renderSubFrequency = computed(() => {
    if(!selectedVariant.value.has_subscription_plan) return null;

    return selectedVariant.value.selling_plans.map(plan => ({
      id: plan.selling_plan.id,
      name: plan.selling_plan.name
    }));
  })

  const subscriptionVariants = (variant) => {
    const { variants } = product.value;
    const item = selectedVariant.value || variants[0];
    const { options } = item;

    return variants.find(variant =>
      options.slice(0, options.length - 1).every((option, index) =>
        variant.options[index] === option
      ) && 
      variant.options[options.length - 1] !== 'One Time Purchase' &&
      variant.selling_plans.length > 0
    );
  }

  const onSubscriptionChange = (value) => {
    const { variants } = product.value;
    const { options } = selectedVariant.value;
    const lastOptionIndex = options.length - 1;

    const filteredVariants = variants.filter(variant =>
      options.slice(0, options.length - 1).every((option, index) =>
        variant.options[index] === option
      )
    );

    if(value) {
      const subscriptionVariants = filteredVariants.filter(variant =>
        variant.options[lastOptionIndex] !== 'One Time Purchase' &&
        variant.has_subscription_plan
      );

      if (subscriptionVariants.length) {
        emit('update-option', product.value.options[lastOptionIndex].name ,subscriptionVariants[0].options[lastOptionIndex], lastOptionIndex);
        emit('update-selling-plan', {
          id: subscriptionVariants[0].selling_plans[0].selling_plan.id,
          name: subscriptionVariants[0].selling_plans[0].selling_plan.name
        }, true);
      }
    }else {
      const onetimeVariants = filteredVariants.filter(variant =>
        variant.options[lastOptionIndex] === 'One Time Purchase'
      );

      if(onetimeVariants.length) {
        emit('update-option',product.value.options[lastOptionIndex].name,onetimeVariants[0].options[lastOptionIndex], lastOptionIndex);
      }
    }

    isSubscription.value = value;
    emit('update-is-subscription', value)
  }

  const onSubscriptionOptionChange = (key,value,index) => {
    emit('update-option', key, value, index);
    setTimeout(() => {
      const planExists = renderSubFrequency.value.some(plan => plan.id === selectedSellingPlan.value.id);

      if (!planExists) {
        emit('update-selling-plan', renderSubFrequency.value[0], true);
      }
    })
  }

  const getDiscountPercentage = (variant) => {
    const { compare_at_price: compareAtPrice, price: subscriptionPrice, selling_plans: sellingPlans } = variant;

    if (compareAtPrice <= 0) {
      const sellingPlan = sellingPlans.find(plan => plan.selling_plan.id === selectedSellingPlan.value.id);
      if(sellingPlan) {
        const { value_type: type, value } = sellingPlan.selling_plan.price_adjustments[0];
        return value;
      }else {
        return 0;
      }
    } else {
      return Math.round((compareAtPrice - subscriptionPrice) / compareAtPrice * 100);
    }
  };

  const getFormattedPrice = (price, sellingPlans) => {
    if (window.shopLocation !== 'GB' && isMultiPack.value) {
      return window.formattedPrice(price / 100);
    } else {
      const sellingPlan = sellingPlans.find(plan => plan.selling_plan.id === selectedSellingPlan.value.id);
      if (sellingPlan) {
        return window.formattedPrice((sellingPlan.per_delivery_price / 100).toFixed(2));
      }
      return window.formattedPrice((price / 100).toFixed(2));
    }
  }

  const isMultiPackOption = (option) => {
    return ['boxes', 'tubs', 'bottles'].includes(option.name.toLowerCase());
  };

  const isVariantOptionAvailable = (index, value) => {
    const { options } = selectedVariant.value;
    const { variants } = product.value;

    const optionsMap = [...options];
    optionsMap[index] = value;

    return variants.some(variant =>
      variant.options[0] === optionsMap[0] &&
      variant.options[1] === optionsMap[1] &&
      (index !== 2 || variant.options[2] === optionsMap[2])
    );
  };

  const getOptionUnitPrice = (value) => {
    const { variants } = product.value;
    var item = selectedVariant.value;
    const { options } = item;
    
    const availableSubscriptionVariant = variants.find(variant =>
      options.slice(0, options.length - 1).every((option, index) =>
        variant.options[index] === option
      ) && variant.options[options.length - 1] === value
    );

    if (availableSubscriptionVariant) {
      let subscriptionPackSize = 1;
      const regex = /\d+/g;
      const packDigit = value.match(regex);

      if (packDigit.length) subscriptionPackSize = packDigit[0];

      return formattedPrice(parseInt(availableSubscriptionVariant.price / subscriptionPackSize) / 100);
    }
  };

  const multipackOptionTag = (position, value) => {
    var item = selectedVariant.value;
    const { options } = item;

    const availableVariants = product.value.variants.filter(variant =>
      options.slice(0, options.length - 1).every((option, index) =>
        variant.options[index] === option
      ) && variant.options[options.length - 1] === value
    );

    if (availableVariants.length > 0) {
      const discount = getDiscountPercentage(availableVariants[0]);
      const variant2Pack = availableVariants[0].title.toString().includes('2');
      const variant3Pack = availableVariants[0].title.toString().includes('3');

      if (variant2Pack && discount >= 22.5){
        return 'Best Seller';
      } else if (variant3Pack && discount >= 25) {
        return 'Best Value';
      }
    }
  }

  const toggleFrequencyDrpdwn = () => {
    isFrequencyDrpdwnOpen.value = !isFrequencyDrpdwnOpen.value;
  };

  defineExpose({isSubscription, isFrequencyDrpdwnOpen, onSubscriptionChange})
</script>